import React, { Component } from 'react'
import { translate } from '../../../common/utils'
import ControllerInput from './ControllerInput'
import AddressInput from './AddressInput'
import { Grid, Row, Col } from 'react-bootstrap'

export default class LockInput extends Component {
    constructor(p) {
        super(p)

        this.textInputs = ['custom_name', 'location', 'owner']
        this.checkBoxes = []
    }

    render() {
        const { disabledFields, onChange, controller, address } = this.props

        return (
            <Grid>
                <ControllerInput onChange={(e) => onChange(e, 'controller')} open_duration={controller.open_duration} port_id={controller.port_id} qlocx_id={controller.qlocx_id} />

                <br />

                <Row>
                    {this.textInputs.map(key => {
                        if (disabledFields && disabledFields.indexOf(key) > -1) return null

                        return (
                            <Col key={key} xs={4} md={4} lg={4}>
                                <span>{translate(key)}:</span> <input onChange={this.props.onChange} type="text" name={key} className="form-control qlocxInput" />
                            </Col>
                        )
                    })}
                </Row>

                <br />

                {disabledFields && disabledFields.indexOf('AddressInput') > -1 ? null : <AddressInput onChange={(e) => onChange(e, 'address')} address={address} />}
            </Grid>
        )
    }
}

